import { render, staticRenderFns } from "./ItemBlokkolt.vue?vue&type=template&id=20a6915e&scoped=true&"
import script from "./ItemBlokkolt.vue?vue&type=script&lang=js&"
export * from "./ItemBlokkolt.vue?vue&type=script&lang=js&"
import style0 from "./ItemBlokkolt.vue?vue&type=style&index=0&id=20a6915e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a6915e",
  null
  
)

export default component.exports